import { matchPath } from "react-router";

/**
 * Returns whether the current location matches a list of routes.
 * @param {Object} location - the current location.
 * @param {[string]} routes - a list of routes to match.
 * @param {Object} options - an object with options for React Router's matchPath.
 * @returns {boolean} - whether the location matches the routes.
 */
export function isRouteMatch(
	{ pathname } = window.location,
	routes = [],
	options = {},
) {
	return routes.some((path) => matchPath(pathname, { path, exact: true, ...options }));
}

export default isRouteMatch;



// WEBPACK FOOTER //
// ./src/shared/util/isRouteMatch.js